var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{staticClass:"white--text avatar",attrs:{"color":"primary","size":"34px","tile":""}},[(_vm.isImg)?_c('img',{attrs:{"src":_vm.obj.photoURL,"alt":_vm.obj.name}}):_c('span',[_vm._v(_vm._s(_vm.alias))])])}
var staticRenderFns = []

export { render, staticRenderFns }